import filter from 'lodash/filter'
import findIndex from 'lodash/findIndex'
import includes from 'lodash/includes'

export const getGalleryAssets = (product) => {
  const items = filter(product?.assets, ({ tags }) => includes(tags, ('gallery'))) || []
  const videoIndex = findIndex(items, ({ tags }) => includes(tags, 'video'))
  if (videoIndex !== -1 && videoIndex !== 2) {
    const video = items[videoIndex]
    items.splice(videoIndex, 1)
    items.splice(2, 0, video)
  }
  return items
}
